import React from 'react';
import Button from '@material-ui/core/Button';
import palette from 'theme/palette';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles';

const ButtonComponent = props => {
  const classes = makeStyles(styles())();

  const getBackgroundColor = props => {
    if (props.variant === 'contained') {
      return props.color === 'secondary'
        ? palette().secondary.main
        : palette().primary.main;
    } else {
      return props.color === 'secondary' ? palette().black : palette().white;
    }
  };

  const getBorderColor = props => {
    return props.color === 'secondary'
      ? palette().secondary.main
      : palette().primary.main;
  };

  const getTextColor = props => {
    if (props.variant === 'contained') {
      return props.color === 'secondary' ? palette().black : palette().white;
    } else {
      return props.color === 'secondary'
        ? palette().secondary.main
        : palette().primary.main;
    }
  };

  return (
    <Button
      style={{
        backgroundColor: getBackgroundColor(props),
        border: `solid 1px ${getBorderColor(props)}`,
        color: getTextColor(props),
        ...props.style,
      }}
      className={classes.button}
      {...props}
    />
  );
};

export default ButtonComponent;
